import * as React from 'react';
import { Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { required, minLength, maxLength, minValue, maxValue, number, regex, email, choices, NumberField } from 'react-admin';
import {
  useRedirect,
  List,
  Datagrid,
  Filter,
  Edit,
  Create,

  Toolbar,
  TopToolbar,
  DeleteWithConfirmButton,
  BulkDeleteWithConfirmButton,
  Show,
  SimpleShowLayout,

  ReferenceField,
  TextField,
  ImageField,
  BooleanField,

  SimpleForm,
  ReferenceInput,
  SelectInput,
  TextInput,
  NumberInput,
  BooleanInput,
  NullableBooleanInput,

  Button,
  EditButton,
  ShowButton,
  SaveButton,
  FunctionField
} from 'react-admin';
import { UpLoadFile, PreviewImage, FirstImageField } from './custom/UpLoadFile';
import { ArrowBack } from '@material-ui/icons';
import { CustomRichTextInput } from './custom/CustomRichTextInput';
//import ResetOrderNum from './SHOW_Video_ResetOrderNum';

{/* 
  import { SHOW_VideoList, SHOW_VideoCreate, SHOW_VideoEdit, SHOW_VideoShow } from './components/SHOW_Video';

  <Resource name="CMSSHOW_Video" list={SHOW_VideoList} create={SHOW_VideoCreate} edit={SHOW_VideoEdit} show={SHOW_VideoShow} />
  <Resource name="CMSSHOW_Video" list={ListGuesser} create={EditGuesser} edit={EditGuesser} edit={ShowGuesser} /> 
*/}

const useStyles = makeStyles({
  imageField: {
    '& img': { width: 60 }
  },
});

const useTxtData = {
  page: {
    tableName: 'SHOW_Video',
  },
  table: {
    id: 'id',
    Title: '标题',
    Pics: '封面图片',
    VideoPath: '视频',
    Show: '展示',
    OrderNum: '排序',
    UpTime: '更新时间',
    Content: '介绍',
    ShowCount:'浏览量'
  }
};

//分页列表页面
export const SHOW_VideoList = (props) => {
  //筛选器模块
  const Filters = (props) => {
    return (
      <Filter {...props}>
        <TextInput label="ID" source="id" alwaysOn resettable />
        {/* <TextInput label="XX" source="name" alwaysOn resettable /> */}
      </Filter>
    );
  };
  //批量操作模块
  const AssetBulkActionButtons = (props) => {
    return (
      <Fragment>
        {/* <ResetOrderNum label="重置排序" {...props} /> */}
        <BulkDeleteWithConfirmButton {...props} confirmTitle="删除确认" confirmContent="确认要删除所选记录吗？" />
      </Fragment>
    );
  };
  //行右侧功能按钮
  const RowAction = (props) => {
    return (
      <div style={{ textAlign: 'right' }}>
        <EditButton {...props} /><br />
        {/* <ShowButton {...props} /><br /> */}
        <DeleteWithConfirmButton {...props} confirmTitle="删除确认" confirmContent="确认要删除该记录吗？" />
      </div>
    );
  }

  const classes = useStyles();
  return (
    <List {...props} title={useTxtData.page.tableName + '列表'} sort={{ field: 'id', order: 'DESC' }} filters={<Filters />} bulkActionButtons={<AssetBulkActionButtons />} >
      <Datagrid>
        {/* <TextField source="id" /> */}
        {/* <TextField label="名称" source="Name" /> */}
        {/* <TextField label="排序" source="OrderNum" />  */}
        {/* <TextField label={useTxtData.table.id} source="id" /> */}
        <TextField label={useTxtData.table.Title} source="Title" />
        {/* <PreviewImage label={useTxtData.table.Pic} source="Pic" className={classes.imageField} 
        aliPicResize='?x-oss-process=image/resize,w_100,m_lfit' /> */}
        <FirstImageField label={useTxtData.table.Pics} source="Pics" className={classes.imageField} aliPicResize='?x-oss-process=image/resize,w_100,m_lfit' />
        {/* <PreviewImage label={useTxtData.table.VideoPath} source="VideoPath" /> */}
        <FunctionField label={useTxtData.table.VideoPath} render={(record) => <a target={'_blank'} href={record.VideoPath}>视频</a>} />
        <BooleanField label={useTxtData.table.Show} source="Show" />
        <TextField label={useTxtData.table.OrderNum} source="OrderNum" />
        <TextField label={useTxtData.table.ShowCount} source="ShowCount" />
        {/* <TextField label={useTxtData.table.UpTime} source="UpTime" /> */}
        <RowAction />
      </Datagrid>
    </List>
  );
};

////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////

//SHOW页面
export const SHOW_VideoShow = (props) => {
  const ShowActions = (props) => {
    const { basePath, data } = props; const redirect = useRedirect();
    return (
      <TopToolbar>
        <Button label="返回列表" onClick={() => redirect(basePath)} variant="text">
          <ArrowBack />
        </Button>
        <EditButton basePath={basePath} record={data} />
      </TopToolbar>
    );
  };

  const classes = useStyles();
  return (
    <Show title={'查看' + useTxtData.page.tableName} {...props} actions={<ShowActions />}>
      <SimpleShowLayout>
        {/* <TextField source="id" /> */}
        {/* <TextField label="名称" source="Name" /> */}
        {/* <TextField label="排序" source="OrderNum" />  */}
        <TextField label={useTxtData.table.id} source="id" />
        <TextField label={useTxtData.table.Title} source="Title" />
        {/* <TextField label={useTxtData.table.Pic} source="Pic" /> */}
        <FirstImageField label={useTxtData.table.Pics} source="Pics" className={classes.imageField} />
        <TextField label={useTxtData.table.VideoPath} source="VideoPath" />
        <TextField label={useTxtData.table.Show} source="Show" />
        <TextField label={useTxtData.table.OrderNum} source="OrderNum" />
        <TextField label={useTxtData.table.UpTime} source="UpTime" />
      </SimpleShowLayout>
    </Show>
  );
}

////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////

//编辑页面
export const SHOW_VideoEdit = (props) => {
  const PostEditActions = (props) => {
    const { basePath } = props; const redirect = useRedirect();
    return (
      <TopToolbar {...props}>
        <Button label="返回列表" onClick={() => redirect(basePath)} variant="text">
          <ArrowBack />
        </Button>
      </TopToolbar>
    );
  };
  const PostEditToolbar = (props) => {
    return (
      <Toolbar {...props}>
        <SaveButton />
      </Toolbar>
    );
  };
  return (
    <Edit title={'编辑' + useTxtData.page.tableName} undoable={false} {...props} actions={<PostEditActions />}>
      <MyForm Edit={true} toolbar={<PostEditToolbar />} />
    </Edit>
  );
};

////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////

//创建页面
export const SHOW_VideoCreate = (props) => {
  const PostCreateActions = (props) => {
    const { basePath } = props; const redirect = useRedirect();
    return (
      <TopToolbar {...props}>
        <Button label="返回列表" onClick={() => redirect(basePath)} variant="text" >
          <ArrowBack />
        </Button>
      </TopToolbar>
    );
  };
  const PostCreateToolbar = (props) => {
    const { basePath } = props;
    return (
      <Toolbar {...props}>
        <SaveButton label="保存&列表" redirect={basePath} submitOnEnter={true} />
        <SaveButton label="保存&继续" redirect={false} submitOnEnter={false} variant="text" />
      </Toolbar>
    );
  };

  return (
    <Create title={'新增' + useTxtData.page.tableName} undoable={false} {...props} actions={<PostCreateActions />}>
      <MyForm Create={true} toolbar={<PostCreateToolbar />} />
    </Create>
  );
};

////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////
//Create和Edit公用表单
const MyForm = (props) => {
  let { Edit, Create } = props;
  return (
    <SimpleForm {...props} >
      {/* <TextInput source="Name" /> */}
      {/* <NumberInput source="OrderNum" /> */}
      {/* <TextInput label={useTxtData.table.id} source="id" validate={[required()]} /> */}
      <TextInput label={useTxtData.table.Title} source="Title" validate={[required()]} />
      {/* <UpLoadFile label={useTxtData.table.Pic} source="Pic" validate={[required()]} /> */}
      <UpLoadFile multiple label={useTxtData.table.Pics} source="Pics" validate={[required()]} />
      <UpLoadFile notImg label={useTxtData.table.VideoPath} source="VideoPath" validate={[]} accept={'video/mp4'} />
      <BooleanInput label={useTxtData.table.Show} source="Show" validate={[required()]} defaultValue={true} />
      <NumberInput label={useTxtData.table.OrderNum} source="OrderNum" validate={[required()]} defaultValue={0} />
      {/* <TextInput label={useTxtData.table.UpTime} source="UpTime" validate={[required()]} /> */}
      <CustomRichTextInput label={useTxtData.table.Content} source="Content" />
    </SimpleForm>
  );
}